import React from 'react';
import { Card, CardContent, Typography } from '@mui/material';

const CancelsMetricCard = ({ label, value }) => (
  <Card sx={{ height: '100%' }}>
    <CardContent>
      <Typography variant="caption" color="text.secondary">
        {label}
      </Typography>
      <Typography variant="h6">{value}</Typography>
    </CardContent>
  </Card>
);

export default CancelsMetricCard;
